"use client";

import type { ReactNode } from "react";

import { cn } from "../../utils/cn.util";
import { useLayoutContext } from "./context";

export type LayoutSidebarBodyProps = {
  children: ReactNode;
  className?: string;
};

const SidebarBody = ({ children, className }: LayoutSidebarBodyProps) => {
  const { openSidebar } = useLayoutContext();

  return (
    <div
      className={cn(
        "flex flex-1 flex-col gap-6 pr-2.5 pl-6 transition-[padding] duration-200 ease-in-out",
        !openSidebar && "px-3",
        className
      )}
    >
      {children}
    </div>
  );
};

export default SidebarBody;
